import React, { useState, useEffect, useRef } from 'react';
import './Trading.css';
import TradePanel from './TradePanel';
import ActiveTrades from './ActiveTrades';

const Trading = () => {
  const [selectedSymbol, setSelectedSymbol] = useState('BTC');
  const containerRef = useRef();

  // Trust Wallet Assets CDN - Ye 100% stable icons hain
  const topAssets = [
    { name: 'BTC', icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/bitcoin/info/logo.png' },
    { name: 'ETH', icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png' },
    { name: 'SOL', icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/solana/info/logo.png' },
    { name: 'BNB', icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png' },
    { name: 'XRP', icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/xrp/info/logo.png' },
    { name: 'DOGE', icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/doge/info/logo.png' },
  ];

  useEffect(() => {
    if (containerRef.current) {
        containerRef.current.innerHTML = '';
    }

    const script = document.createElement('script');
    script.id = 'tradingview-widget-script';
    script.src = 'https://s3.tradingview.com/tv.js';
    script.async = true;
    script.onload = () => {
      if (window.TradingView && containerRef.current) {
        new window.TradingView.widget({
          container_id: containerRef.current.id,
          symbol: `BINANCE:${selectedSymbol}USDT`, //
          interval: '15',
          theme: 'light',
          height: 380,
          width: '100%',
          style: "1",
          locale: "en",
          enable_publishing: false,
          hide_top_toolbar: false,
          save_image: false,
        });
      }
    };
    document.head.appendChild(script);
    return () => {
        const oldScript = document.getElementById('tradingview-widget-script');
        if (oldScript) oldScript.remove();
    };
  }, [selectedSymbol]);

  return (
    <div className="trading-page-v2">
      {/* Full-Width Grid */}
      <div className="asset-selection-grid">
        {topAssets.map((asset) => (
          <div 
            key={asset.name} 
            className={`asset-card ${selectedSymbol === asset.name ? 'active' : ''}`}
            onClick={() => setSelectedSymbol(asset.name)}
          >
            <div className="icon-wrapper">
              <img 
                src={asset.icon} 
                alt={asset.name} 
                className="asset-icon-img"
                // Agar internet slow ho ya image block ho to fallback
                onError={(e) => { 
                  e.target.onerror = null; 
                  e.target.src = `https://ui-avatars.com/api/?name=${asset.name}&background=f0b90b&color=fff&bold=true`; 
                }} 
              />
            </div>
            <span className="asset-ticker">{asset.name}</span>
            {selectedSymbol === asset.name && <div className="active-bar-indicator"></div>}
          </div>
        ))}
      </div>

      <div id="tradingview_chart" ref={containerRef} className="chart-top"></div>
      
      <TradePanel onTradeExecute={(data) => console.log(data)} />
<ActiveTrades selectedSymbol={selectedSymbol} />      
      <div className="bottom-nav-spacer"></div>
    </div>
  );
};

export default Trading;